// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2vbcN","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__o13nn"};